import { onAuthStateChanged } from 'firebase/auth';
import { auth } from '../firebase';
import { API_BASE_URL } from './config';
import { appVersion } from './styleCatalog';

export async function getAuthHeaders(baseHeaders = {}) {
  let user = auth.currentUser;
  if (!user) {
    user = await new Promise(resolve => {
      let unsubscribe = () => {};
      const timeout = setTimeout(() => { unsubscribe(); resolve(null); }, 2000);
      unsubscribe = onAuthStateChanged(auth, next => { clearTimeout(timeout); unsubscribe(); resolve(next); });
    });
  }
  if (!user || user.isAnonymous) throw new Error('로그인이 필요합니다. 다시 로그인해 주세요.');
  return { 'X-App-Version': appVersion, ...baseHeaders, Authorization: `Bearer ${await user.getIdToken()}` };
}

export class ApiError extends Error {
  constructor(message, status, data = {}) { super(message); this.status = status; this.data = data; }
}
export async function parseJSONResponse(response) {
  const data = await response.json().catch(() => ({}));
  if (!response.ok) {
    if (data.service_notice && typeof document !== 'undefined') {
      document.dispatchEvent(new CustomEvent('serviceNotice', { detail: data.service_notice }));
    }
    throw new ApiError(data.error || data.message || `요청을 처리하지 못했습니다. (${response.status})`, response.status, data);
  }
  return data;
}
export async function request(path, { method = 'GET', body, authenticated = true, signal } = {}) {
  const base = body instanceof FormData ? {} : body !== undefined ? { 'Content-Type': 'application/json' } : {};
  const headers = authenticated ? await getAuthHeaders(base) : { 'X-App-Version': appVersion, ...base };
  const response = await fetch(`${API_BASE_URL}${path}`, {
    method, headers, signal,
    ...(body !== undefined ? { body: body instanceof FormData ? body : JSON.stringify(body) } : {})
  });
  return parseJSONResponse(response);
}
